module.exports = __webpack_public_path__ + "media/images/play-4fbfec9b298ff423c265afe08b491416.svg";